import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Search } from '@zapsa/zap-redux-forms-components';

import { generateAction } from 'common/helpers';
import { languages } from 'common/constants';

const validate = () => {
  const errors = {};

  return errors;
};

class LanguageFormView extends Component {
  static propTypes = {
    setLang: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit} style={{ width: '50%' }}>
        <Field
          name="lang"
          label={this.props.translations['lang.language']}
          component={Search}
          className="transparent-search form-group--minimal"
          options={languages}
          searchable={false}
          valueRenderer={option => (
            <div className="select-option-block">
              <span>{option.label}</span>
            </div>
          )}
          optionRenderer={option => (
            <div className="select-option-block">
              <span>{option.label}</span>
            </div>
          )}
          onChange={(val) => {
            localStorage.setItem('lang', val.value);
            this.props.setLang({ lang: val.value });
          }}
        />
      </form>
    );
  }
}

const LanguageFormContainer = reduxForm({
  form: 'languageForm',
  validate,
  initialValues: {
    lang:
      !localStorage.getItem('lang')
      && window.navigator.language
      && languages.find(lang => lang === window.navigator.language.split('-')[0])
        ? window.navigator.language.split('-')[0]
        : localStorage.getItem('lang')
          ? localStorage.getItem('lang')
          : 'en',
  },
})(LanguageFormView);

const LanguageForm = connect(
  state => ({
    translations: state.i18n.translations[state.i18n.lang],
  }),
  dispatch =>
    bindActionCreators(
      {
        setLang: generateAction({
          actionType: 'SET_LANG',
        }),
      },
      dispatch,
    ),
)(LanguageFormContainer);

export default LanguageForm;
